<script setup lang="ts">
import {onMounted, Ref, ref, watch} from 'vue'
import api from "@/app/services/api.ts";
import type {AxiosResponse} from "axios"
import {Country} from "@/commons/types/das.ts";

const props = defineProps({
  data: {
    type: String,
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', countryId: string): void
}>()

const selectedCountryId = ref('')
const countries:Ref<Country[]> = ref([])
const selectedCountry = ref<Country | undefined>()

onMounted(() => {
  fetchCountries()
})

const fetchCountries = async () => {
  return api
      .get(`/configuration/address/country`)
      .then((response: AxiosResponse<Country[]>) => {
        countries.value = response.data
        // Once countries are fetched, find the selected country
        if (props.data) {
          selectedCountry.value = countries.value.find(c => c.id === props.data)
        }
      })
}

// Watch for data prop changes
watch(() => props.data, (newValue) => {
  if (newValue && countries.value.length > 0) {
    selectedCountry.value = countries.value.find(c => c.id === newValue)
  }
})

watch(selectedCountryId, (newValue) => {
  emit('update:modelValue', newValue)
})

</script>

<template>
  <div class="flex flex-col">
    <div v-if="selectedCountry" class="p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center">
        <i class="fa fa-flag text-primary text-xl mr-3"></i>
        <div>
          <p class="text-sm text-gray-500 uppercase tracking-wide">Country</p>
          <p class="text-lg font-semibold text-gray-900">{{ selectedCountry.name }}</p>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-8 text-gray-500 text-sm">
      <i class="fa fa-globe text-3xl mb-2"></i>
      <p>No country selected</p>
    </div>
  </div>
</template>

<style scoped></style>
